import { MenuItem, Select, SelectChangeEvent } from '@mui/material';
import { useCallback } from 'react';
import { SettingsInputProps } from './SettingsInputProps';

export const MultiSelectSettingsInput = (props: SettingsInputProps) => {
  const onChange = useCallback((ev: SelectChangeEvent<string[] | string>) => {
    const newValue = ev.target.value;
    props.onChange({
      stringArrayValue:
        typeof newValue === 'string' ? newValue.split(',') : newValue,
    });
  }, []);

  return (
    <Select
      fullWidth
      size='small'
      multiple
      value={props.value?.stringArrayValue ?? []}
      onChange={onChange}
    >
      {(props.options ?? []).map((option) => (
        <MenuItem key={option.value} value={String(option.value)}>
          {option.label}
        </MenuItem>
      ))}
    </Select>
  );
};
